import React, { Component } from 'react';
import Zoom from 'react-reveal/Zoom';


export class Geek extends Component {
  render() {
    return (
      <div>
        <Zoom>
        <p>I'm a big Dallas sports fan, mostly for the Cowboys and the Stars. #CowboyNation #VictoryRising<br/><br/></p>
        <p>How can I be a programmer without joining the geek side? I'm a HUGE Star Wars fan. I'm also a moderate gamer.<br/><br/> I love the Elder Scrolls, Fallout, Gears of War, and Halo series, among others, and, of course, you might catch me with the latest Madden or NHL games. Any game that lets me express creatively is also a plus.<br/><br/> Calling you out, Minecraft.<br/><br/></p>
        </Zoom>
      </div>
    )
  }
}

export default Geek;



// WEBPACK FOOTER //
// ./src/components/pages/About/Abouts/Geek.js